import { IconButton, Link } from '@material-ui/core'
import { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'

const StyledIconButton = styled(IconButton)`
  && {
    padding: 0px;
  }
`
export interface IFooterSocialLinkProps {
  onClick?: (ev) => void
  linkIcon?: ReactNode
  to?: string
}

export const FooterSocialLink = ({ onClick, linkIcon, to }: PropsWithChildren<IFooterSocialLinkProps>) => {
  return (
    <>
      <Link href={to} target="_blank">
        <StyledIconButton onClick={onClick}>{linkIcon}</StyledIconButton>
      </Link>
    </>
  )
}
